// Central place for the (placeholder) Formspree endpoint.
// Swap this string for the real endpoint when ready.
export const FORMSPREE_ENDPOINT = "https://formspree.io/f/maqkgnaq";

// ServiceM8 online booking link (opens in a new tab)
export const BOOKING_URL =
  "https://book.servicem8.com/request_booking?uuid=7a951526-7f01-41d8-8aaa-69839e49664b";

export const BUSINESS = {
  name: "Conan Sharman Plumbing and Drain Cleaning Ltd",
  shortName: "Conan Sharman Plumbing",
  phone: "07732471565",
  phoneHref: "tel:07732471565",
  email: "info@conansharmanplumbing.co.uk",
  emailHref: "mailto:info@conansharmanplumbing.co.uk",
  tagline: "Serving Edinburgh & Surrounding Areas",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_253c89d7-3b8a-419a-a470-22784a1036f8/artifacts/vw190o90_images.png",
  springbokUrl:
    "https://customer-assets.emergentagent.com/job_drain-experts-ed/artifacts/eokdzpgy_images-removebg-preview-removebg-preview.png",
  gallery: {
    commercial: [
      {
        url: "https://customer-assets.emergentagent.com/job_drain-experts-ed/artifacts/rkjzjumb_Commercial.jpeg",
        caption: "Commercial washroom — basins & urinals",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_drain-experts-ed/artifacts/0ekk3g58_Commercial%201.jpeg",
        caption: "Accessible WC fit-out",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_drain-experts-ed/artifacts/rd1mmyfd_Commercial%202.jpeg",
        caption: "Commercial cubicles & flooring",
      },
      {
        url: "https://customer-assets.emergentagent.com/job_drain-experts-ed/artifacts/wiqf07pj_Commercial%203.jpeg",
        caption: "Vanity unit & twin vessel basins",
      },
    ],
    projects: [
      {
        label: "Bathroom Refurbishment — 01",
        items: [
          {
            url: "https://customer-assets.emergentagent.com/job_drain-experts-ed/artifacts/7yav8pd3_Bathroom%20before.jpeg",
            type: "before",
            caption: "Before",
          },
          {
            url: "https://customer-assets.emergentagent.com/job_drain-experts-ed/artifacts/rd9ii50e_Bathroom%20after.jpeg",
            type: "after",
            caption: "After",
          },
        ],
      },
      {
        label: "Bathroom Refurbishment — 02",
        items: [
          {
            url: "https://customer-assets.emergentagent.com/job_drain-experts-ed/artifacts/7dkytunv_Bathroom%202%20before.jpeg",
            type: "before",
            caption: "Before",
          },
          {
            url: "https://customer-assets.emergentagent.com/job_drain-experts-ed/artifacts/8fdzdoyo_Bathroom%202%20after%201.jpeg",
            type: "after",
            caption: "After — WC & vanity",
          },
          {
            url: "https://customer-assets.emergentagent.com/job_drain-experts-ed/artifacts/eebqoenf_Bathroom%202%20after%202.jpeg",
            type: "after",
            caption: "After — wet room shower",
          },
        ],
      },
    ],
  },
};
